<template>
  <div id="drawer-wrap">
    <el-drawer
      title="指标1"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
      size="60%"
    >
      <div class="form-wrap">
        <el-form
          :label-position="'top'"
          ref="form"
          :model="FormData"
          label-width="80px"
        >
          <el-form-item label="任务名称" class="block-label">
            <el-input v-model="FormData.name"></el-input>
          </el-form-item>
          <el-form-item label="指标值" class="block-label">
            <el-input v-model="FormData.zbv"></el-input>
          </el-form-item>
          <el-form-item label="开始时间" class="block-label">
            <el-input v-model="FormData.timeStart"></el-input>
          </el-form-item>
          <el-form-item label="结束时间" class="block-label">
            <el-input v-model="FormData.timeEnd"></el-input>
          </el-form-item>
          <el-form-item label="产品列表" class="block-label">
            <el-table
              :data="tableData"
              style="width: 100%"
            >
              <el-table-column
                prop="date"
                label="日期"
                width="180"
              >
              </el-table-column>
              <el-table-column
                prop="name"
                label="姓名"
                width="180"
              >
              </el-table-column>
              <el-table-column
                prop="address"
                label="地址"
                width="180"
              >
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item class="item-btns">
            <el-button
              :loading="wating"
              type="primary"
              size="mini"
              @click="onSubmit"
            >
              立即创建
            </el-button>
            <el-button size="mini">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { defineExpose, onMounted, reactive, ref, watch, getCurrentInstance, nextTick } from '@vue/composition-api'
export default {
  name: 'DrawerWrapper',
  props: [],
  setup (props, ctx) {
    let wating = ref(false)
    let drawer = ref(false)
    let direction = 'rtl'
    console.log(ctx)
    let handleClose = function () {
      drawer.value = false
    }
    let openDrawer = function () {
      drawer.value = true
    }

    let FormData = ref({
      name: '任务名称',
      zbv: '指标值',
      productLists: [{
        code: 1,
        val: 0
      }]
    })
    let onSubmit = function () {
      if (wating.value) { return }
      wating.value = true
      ctx.emit('addNodeComfirm', { options: { ...FormData.value }, type: 1 })
      setTimeout(() => {
        wating.value = false
        handleClose()
      }, 300)
    }
    let tableData = ref([{
      date: '2016-05-02',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1518 弄'
    }, {
      date: '2016-05-04',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1517 弄'
    }, {
      date: '2016-05-01',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1519 弄'
    }, {
      date: '2016-05-03',
      name: '王小虎',
      address: '上海市普陀区金沙江路 1516 弄'
    }])
    return {
      drawer,
      direction,
      handleClose,
      openDrawer,
      FormData,
      tableData,
      onSubmit,
      wating
    }
  },

  components: {

  }
}
</script>

<style scoped lang="stylus">
.form-wrap
  padding: 10px

.item-btns
  text-align: right
</style>
